import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { CurrencyProvider } from "./lib/currency";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Auctions from "./pages/Auctions";
import AuctionDetail from "./pages/AuctionDetail";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Sell from "./pages/Sell";
import HowItWorks from "./pages/HowItWorks";
import SellerDashboard from "./pages/SellerDashboard";
import BuyerDashboard from "./pages/BuyerDashboard";
import Watchlist from "./pages/Watchlist";
import Checkout from "./pages/Checkout";
import AdminDashboard from "./pages/AdminDashboard";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BidzStore from "./pages/BidzStore";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC] dark:bg-slate-950 text-slate-900 dark:text-slate-100">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/auctions" element={<Auctions />} />
            <Route path="/auction/:id" element={<AuctionDetail />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/sell" element={<Sell />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/seller" element={<SellerDashboard />} />
            <Route path="/buyer" element={<BuyerDashboard />} />
            <Route path="/watchlist" element={<Watchlist />} />
            <Route path="/checkout/:orderId" element={<Checkout />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/bidz" element={<BidzStore />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}
